<template>
  <NavbarOne />
  <MainBanner />
  <StreetAddressesApartments />
  <OurServices />
  <BlastOff />
  <PoweringDailyLife />
  <WhyChooseUs />
  <PartnerLogo />
  <PricingPlans />
  <OurTestimonial />
  <OurLatestArticles class="pt-100" />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import MainBanner from "@/components/ISPProvider/MainBanner.vue";
import StreetAddressesApartments from "@/components/ISPProvider/StreetAddressesApartments.vue";
import OurServices from "@/components/ISPProvider/OurServices.vue";
import BlastOff from "@/components/ISPProvider/BlastOff.vue";
import PoweringDailyLife from "@/components/ISPProvider/PoweringDailyLife.vue";
import WhyChooseUs from "@/components/ISPProvider/WhyChooseUs.vue";
import PartnerLogo from "@/components/ISPProvider/PartnerLogo.vue";
import PricingPlans from "@/components/ISPProvider/PricingPlans.vue";
import OurTestimonial from "@/components/ISPProvider/OurTestimonial.vue";
import OurLatestArticles from "@/components/Common/OurLatestArticles.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "ISPProviderPage",
  components: {
    NavbarOne,
    MainBanner,
    StreetAddressesApartments,
    OurServices,
    BlastOff,
    PoweringDailyLife,
    WhyChooseUs,
    PartnerLogo,
    PricingPlans,
    OurTestimonial,
    OurLatestArticles,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "اشتراكات IPTV لجميع الأجهزة | جودة HD و4K وثبات عالي",
      meta: [
        {
          name: "description",
          content:
            "احصل على اشتراك IPTV يعمل على Smart TV، Android TV، الهواتف الذكية وأجهزة الاستقبال. استمتع بالقنوات العربية والعالمية، الأفلام والمسلسلات بجودة HD و4K مع سيرفرات مستقرة.",
        },
        {
          name: "keywords",
          content:
            "اشتراك IPTV, IPTV Smart TV, Android TV, IPTV 4K, IPTV HD, قنوات عربية, قنوات عالمية, أفلام, مسلسلات, IPTV لجميع الأجهزة",
        },
        {
          property: "og:title",
          content: "اشتراكات IPTV لجميع الأجهزة | جودة HD و4K",
        },
        {
          property: "og:description",
          content:
            "شاهد آلاف القنوات العربية والعالمية والأفلام والمسلسلات على جميع أجهزتك بجودة عالية وثبات ممتاز.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/isp-provider",
        },
      ],
    });
  },
});
</script>